import { useMemo, useState } from "react";
import SectionHeading from "./SectionHeading";
import { relatedDirections } from "@/mocks/movieContent";

const iconByCategory: Record<string, string> = {
  都市情感: "ri-building-2-line",
  伦理剧情: "ri-scales-3-line",
  怀旧氛围: "ri-history-line",
  氛围影像: "ri-image-2-line",
};

export default function RelatedSection() {
  const categories = useMemo(
    () => ["全部", ...Array.from(new Set(relatedDirections.map((item) => item.category)))],
    []
  );
  const [active, setActive] = useState("全部");

  const list = active === "全部" ? relatedDirections : relatedDirections.filter((item) => item.category === active);

  return (
    <section id="related" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow="相关推荐"
          title="相关推荐：如果你喜欢这种口味，可以往哪里看"
          description="这里不是片单，而是按“观看方向”整理出的几类线索。你可以按题材筛选，找到更符合自己偏好的方向。"
          icon="ri-compass-3-line"
        />

        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => setActive(cat)}
              className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                active === cat
                  ? "bg-secondary-500 text-background-50 font-medium"
                  : "bg-background-50 text-foreground-700 border border-background-300 hover:border-secondary-300"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {list.map((item) => (
            <article
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex items-center gap-2 text-secondary-700">
                <i className={`${iconByCategory[item.category] ?? "ri-film-line"} text-lg`}></i>
                <span className="text-xs font-label tracking-wide">{item.category}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950 leading-snug">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 rounded-full bg-background-200 text-foreground-700 text-xs whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}